import { EHouseMaterial } from '../../../../api-models/common/json_query';

export const HOUSE_MATERIAL_MAP_VALUE_TO_LABEL = {
  [EHouseMaterial.Brick]: 'кирпичный',
  [EHouseMaterial.Monolith]: 'монолитный',
  [EHouseMaterial.Panel]: 'панельный',
  [EHouseMaterial.Block]: 'блочный',
  [EHouseMaterial.Wood]: 'деревянный',
  [EHouseMaterial.Stalin]: 'сталинский',
  [EHouseMaterial.Shield]: 'щитовой',
  [EHouseMaterial.BrickMonolith]: 'кирпично-монолитный',
  [EHouseMaterial.Wireframe]: 'каркасный',
  [EHouseMaterial.AerocreteBlock]: 'газобетонный блок',
  [EHouseMaterial.GasSilicateBlock]: 'газосиликатный блок',
  [EHouseMaterial.FoamConcreteBlock]: 'пенобетонный блок',
};
